import ProductPrinter from "./productPrinter";

export default class ConnectorPrinter extends ProductPrinter {

  async printOnClick(event) {
    await super.printOnClick(event);
  }
}
